import { render, staticRenderFns } from "./ttshop_usermyorder.vue?vue&type=template&id=a184c790&scoped=true&"
import script from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
export * from "./ttshop_usermyorder.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_usermyorder.vue?vue&type=style&index=0&id=a184c790&lang=scss&scoped=true&"
import style1 from "./ttshop_usermyorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a184c790",
  null
  
)

export default component.exports